import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

export const Skeleton = styled.div`
  background: linear-gradient(90deg, #1b1c1e 25%, #2a2b2d 50%, #1b1c1e 75%);
  border: 1px solid rgba(255, 255, 255, 0.05);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s linear infinite;
`;
